
import { Card, Col, Container, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSnowflake, faHome, faCapsules, faFlask } from '@fortawesome/free-solid-svg-icons'
import './Links.css'


const Links = () => {
    return(
        <main className='links'>
            <Container>
                <h2>Visita cada página para ver nuestros servicios</h2>
                <Row className='justify-content-center align-items-center' xs={2} md={3} xl={5}>
                    <Col>
                        <Link to={'/frio-industrial'}>
                            <Card>
                                <FontAwesomeIcon icon={faSnowflake} />
                                <h3>Frío Industrial</h3>
                            </Card>
                        </Link>
                    </Col>
                    <Col>   
                        <Link to={'/laboratorio'}>
                            <Card>
                                <FontAwesomeIcon icon={faFlask} />
                                <h3>Laboratorio</h3>
                            </Card>
                        </Link>
                    </Col>
                    <Col>
                        <Link to={'/farmacia'}>
                            <Card>
                                <FontAwesomeIcon icon={faCapsules} />
                                <h3>Farmacia</h3>
                            </Card>
                        </Link>
                    </Col>
                    <Col>
                        <Link to={'/climatizacion'}>
                            <Card>
                                <FontAwesomeIcon icon={faHome} />
                                <h3>Climatización</h3>
                            </Card>
                        </Link>
                    </Col>
                </Row>
            </Container>
        </main>
    )
}

export default Links